/*
 * Copyright (c) 2023 Class Technologies Inc. All rights reserved.
 */

import styled from 'styled-components';
import { Box, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

const NoRecordsDiv = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 48px;
    & > * {
        margin-bottom: 4px;
    }
`;

interface NoRecordsProps {
    message: string;
}

export const NoRecords = (props: PropsWithChildren<NoRecordsProps>) => {
    const { message, children } = props;

    return (
        <NoRecordsDiv>
            <Typography sx={{ mt: 1 }} color="text.secondary">
                {message}
            </Typography>
            {children}
        </NoRecordsDiv>
    );
};
